var lg_6711R1P072B_VCR = {
    name: "6711R1P072B_VCR",
    defaultCommandIndex: 1,
    commands: [
        {
            function: "KEY_POWER",
            name: "KEY_POWER",
            icon: "KEY_POWER",
            command: [68,0,4,105,2,245,1,105,2,84,6,107,35,63,17,104,2,106,156,53,107,123,187,122,218,162],
        },
        {
            // function: "KEY_VCR",
            function: "KEY_SOURCE",
            name: "KEY_SOURCE",
            icon: "KEY_SOURCE",
            command: [68,0,4,105,2,245,1,105,2,84,6,107,35,63,17,104,2,106,156,53,107,123,175,85,171,226],
        },
        {
            function: "KEY_EJECTCD",
            name: "KEY_EJECTCD",
            icon: "KEY_EJECTCD",
            command: [68,0,4,105,2,245,1,105,2,84,6,107,35,63,17,104,2,106,156,53,107,123,191,234,170,162],
        },
        {
            function: "AV",
            name: "AV",
            icon: "AV",
            command: [68,0,4,105,2,245,1,105,2,84,6,107,35,63,17,104,2,106,156,53,107,123,181,182,237,162],
        },
        {
            function: "KEY_1",
            name: "KEY_1",
            icon: "KEY_1",
            command: [68,0,4,105,2,245,1,105,2,84,6,107,35,63,17,104,2,106,156,53,107,123,173,253,170,162],
        },
        {
            function: "KEY_2",
            name: "KEY_2",
            icon: "KEY_2",
            command: [68,0,4,105,2,245,1,105,2,84,6,107,35,63,17,104,2,106,156,53,107,123,181,251,170,162],
        },
        {
            function: "KEY_3",
            name: "KEY_3",
            icon: "KEY_3",
            command: [68,0,4,105,2,245,1,105,2,84,6,107,35,63,17,104,2,106,156,53,107,123,170,255,170,162],
        },
        {
            function: "KEY_4",
            name: "KEY_4",
            icon: "KEY_4",
            command: [68,0,4,105,2,245,1,105,2,84,6,107,35,63,17,104,2,106,156,53,107,123,186,250,234,162],
        },
        {
            function: "KEY_5",
            name: "KEY_5",
            icon: "KEY_5",
            command: [68,0,4,105,2,245,1,105,2,84,6,107,35,63,17,104,2,106,156,53,107,123,173,126,234,162],
        },
        {
            function: "KEY_6",
            name: "KEY_6",
            icon: "KEY_6",
            command: [68,0,4,105,2,245,1,105,2,84,6,107,35,63,17,104,2,106,156,53,107,123,181,125,234,162],
        },
        {
            function: "KEY_7",
            name: "KEY_7",
            icon: "KEY_7",
            command: [68,0,4,105,2,245,1,105,2,84,6,107,35,63,17,104,2,106,156,53,107,123,170,191,234,162],
        },
        {
            function: "KEY_8",
            name: "KEY_8",
            icon: "KEY_8",
            command: [68,0,4,105,2,245,1,105,2,84,6,107,35,63,17,104,2,106,156,53,107,123,186,189,122,162],
        },
        {
            function: "KEY_9",
            name: "KEY_9",
            icon: "KEY_9",
            command: [68,0,4,105,2,245,1,105,2,84,6,107,35,63,17,104,2,106,156,53,107,123,173,95,122,162],
        },
        {
            function: "KEY_0",
            name: "KEY_0",
            icon: "KEY_0",
            command: [68,0,4,105,2,245,1,105,2,84,6,107,35,63,17,104,2,106,156,53,107,123,187,245,170,162],
        },
        {
            function: "tv/vcr",
            name: "tv/vcr",
            icon: "tv/vcr",
            command: [68,0,4,105,2,245,1,105,2,84,6,107,35,63,17,104,2,106,156,53,107,123,173,190,218,162],
        },
        {
            function: "KEY_REWIND",
            name: "KEY_REWIND",
            icon: "KEY_REWIND",
            command: [68,0,4,105,2,245,1,105,2,84,6,107,35,63,17,104,2,106,156,53,107,123,183,246,170,162],
        },
        {
            function: "KEY_FORWARD",
            name: "KEY_FORWARD",
            icon: "KEY_FORWARD",
            command: [68,0,4,105,2,245,1,105,2,84,6,107,35,63,17,104,2,106,156,53,107,123,171,254,170,162],
        },
        {
            function: "KEY_PAUSE",
            name: "KEY_PAUSE",
            icon: "KEY_PAUSE",
            command: [68,0,4,105,2,245,1,105,2,84,6,107,35,63,17,104,2,106,156,53,107,123,171,127,106,162],
        },
        {
            function: "KEY_PLAY",
            name: "KEY_PLAY",
            icon: "KEY_PLAY",
            command: [68,0,4,105,2,245,1,105,2,84,6,107,35,63,17,104,2,106,156,53,107,123,189,245,106,162],
        },
        {
            function: "KEY_STOP",
            name: "KEY_STOP",
            icon: "KEY_STOP",
            command: [68,0,4,105,2,245,1,105,2,84,6,107,35,63,17,104,2,106,156,53,107,123,175,250,170,162],
        },
        {
            function: "clk/cnt",
            name: "clk/cnt",
            icon: "clk/cnt",
            command: [68,0,4,105,2,245,1,105,2,84,6,107,35,63,17,104,2,106,156,53,107,123,186,237,117,162],
        },
        {
            function: "KEY_SETUP",
            name: "KEY_SETUP",
            icon: "KEY_SETUP",
            command: [68,0,4,105,2,245,1,105,2,84,6,107,35,63,17,104,2,106,156,53,107,123,181,189,218,162],
        },
        {
            function: "KEY_LEFT",
            name: "KEY_LEFT",
            icon: "KEY_LEFT",
            command: [68,0,4,105,2,245,1,105,2,84,6,107,35,63,17,104,2,106,156,53,107,123,171,247,85,98],
        },
        {
            function: "KEY_RIGHT",
            name: "KEY_RIGHT",
            icon: "KEY_RIGHT",
            command: [68,0,4,105,2,245,1,105,2,84,6,107,35,63,17,104,2,106,156,53,107,123,190,234,173,98],
        },
        {
            function: "KEY_UP",
            name: "KEY_UP",
            icon: "KEY_UP",
            command: [68,0,4,105,2,245,1,105,2,84,6,107,35,63,17,104,2,106,156,53,107,123,183,235,85,98],
        },
        {
            function: "KEY_DOWN",
            name: "KEY_DOWN",
            icon: "KEY_DOWN",
            command: [68,0,4,105,2,245,1,105,2,84,6,107,35,63,17,104,2,106,156,53,107,123,174,246,181,98],
        },
        {
            function: "KEY_OK",
            name: "KEY_OK",
            icon: "KEY_OK",
            command: [68,0,4,105,2,245,1,105,2,84,6,107,35,63,17,104,2,106,156,53,107,123,181,122,245,98],
        },
        {
            function: "KEY_AUDIO",
            name: "KEY_AUDIO",
            icon: "KEY_AUDIO",
            command: [68,0,4,105,2,245,1,105,2,84,6,107,35,63,17,104,2,106,156,53,107,123,175,214,170,226],
        },
        {
            function: "KEY_RECORD",
            name: "KEY_RECORD",
            icon: "KEY_RECORD",
            command: [68,0,4,105,2,245,1,105,2,84,6,107,35,63,17,104,2,106,156,53,107,123,174,253,106,162],
        },
        {
            function: "lock",
            name: "lock",
            icon: "lock",
            command: [68,0,4,105,2,245,1,105,2,84,6,107,35,63,17,104,2,106,156,53,107,123,170,171,254,162],
        },
        {
            function: "marker-search",
            name: "marker-search",
            icon: "marker-search",
            command: [68,0,4,105,2,245,1,105,2,84,6,107,35,63,17,104,2,106,156,53,107,123,175,221,85,162],
        },
        {
            function: "KEY_CLEAR",
            name: "KEY_CLEAR",
            icon: "KEY_CLEAR",
            command: [68,0,4,105,2,245,1,105,2,84,6,107,35,63,17,104,2,106,156,53,107,123,170,175,250,162],
        },
        {
            function: "KEY_AGAIN",
            name: "KEY_AGAIN",
            icon: "KEY_AGAIN",
            command: [68,0,4,105,2,245,1,105,2,84,6,107,35,63,17,104,2,106,156,53,107,123,181,173,119,98],
        },
        {
            function: "lp",
            name: "lp",
            icon: "lp",
            command: [68,0,4,105,2,245,1,105,2,84,6,107,35,63,17,104,2,106,156,53,107,123,189,218,181,162],
        },
        {
            function: "cm-skip",
            name: "cm-skip",
            icon: "cm-skip",
            command: [68,0,4,105,2,245,1,105,2,84,6,107,35,63,17,104,2,106,156,53,107,123,173,90,222,226],
        },
    ]
}
export default lg_6711R1P072B_VCR